import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";
import { addDoc, collection, getDocs, query, Timestamp, where, } from "firebase/firestore";
import { toast } from "react-toastify";
import {
  GoogleMap,
  LoadScript,
  Marker,
  Circle,
  useLoadScript,
} from "@react-google-maps/api";
import BreadCrumb from "../../common/breadcrumb/breadCrumb";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { all_routes } from "../../../../core/data/routes/all_routes";
import React from "react";
import { auth, db, storage } from "../../../../firebase"; // Ensure storage is imported
import { doc, setDoc, getDoc, getFirestore } from "firebase/firestore"; // Corrected Firebase imports
import { format } from "date-fns";
import ImageWithBasePath from "../../../../core/img/ImageWithBasePath";

const libraries = ["places"];
const mapContainerStyle = { width: "100%", height: "400px" };
const center = { lat: 7.2906, lng: 80.6337 }; // Default center: Kandy, Sri Lanka
const googleMapsApiKey = "AIzaSyDiErhyDQa-Cbh9XunmwujWFq7M4eQsVuQ";

const BookingReview = () => {
  const routes = all_routes;
  const location = useLocation();
  const navigate = useNavigate();
  const category = location.state?.category;


  const [lat, setLat] = useState(7.31015); // Default latitude
  const [lon, setLon] = useState(80.639853); // Default longitude
  const [newLocation, setNewLocation] =
    useState<google.maps.LatLngLiteral | null>(null);


  const locationsRef = collection(db, "locations");

  useEffect(() => {
    async function getLocation() {
      try {
        const response = await axios.get("https://ipapi.co/json/");
        setUserLocation(
          `${response.data.city}, ${response.data.region}, ${response.data.country_name}`
        );
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
    getLocation();

    // Fetch last saved location from Firebase
    const fetchLocations = async () => {
      const snapshot = await getDocs(locationsRef);
      if (!snapshot.empty) {
        const lastLocation = snapshot.docs[snapshot.docs.length - 1].data();
        setNewLocation({ lat: lastLocation.lat, lng: lastLocation.lng });
      }
    };
    fetchLocations();
  }, []);

  const handleBookAppointment = () => {
    console.log("Navigating to booking2");
    navigate(routes.bookingPayment, { state: { category } });
  };

  //map-----------------------------Start

  // Fetch Location Start----------------



  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [isFetchingAddress, setIsFetchingAddress] = useState(false);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [error, setError] = useState(null);

  const getAddressFromCoords = async (latitude, longitude) => {
    setIsFetchingAddress(true);
    const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${googleMapsApiKey}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === "OK" && data.results.length > 0) {
        setIsFetchingAddress(false);
        return data.results[0].formatted_address;
      } else {
        setIsFetchingAddress(false);
        return "Address not found";
      }
    } catch (error) {
      console.error("Error fetching address:", error);
      setIsFetchingAddress(false);
      setError("Error fetching address. Please try again.");
      return "Error fetching address";
    }
  };


  const generateCustomId = (): string => {
    const mgPart = `MG${Math.floor(10000 + Math.random() * 90000)}`; // 5-digit random number
    const raPart = `RA${Math.floor(1000 + Math.random() * 9000)}`; // 4-digit random number
    return `${mgPart}${raPart}`;
  };

  const generateOrderNumber = (): number => {
    const timestampPart = Date.now().toString().slice(-10); // Last 10 digits of timestamp
    const randomPart = Math.floor(100000 + Math.random() * 900000); // 6-digit random number
    return parseInt(`${timestampPart}${randomPart.toString().slice(0, 5)}`); // Ensure 15 digits
  };

  ///FIRE BASE ADDED Oders---------------------------------------------------------------

  // import { format } from "date-fns";

  const createLocationInFirebase = async () => {
    if (!mapLocation?.latitude || !mapLocation?.longitude) {
      alert("Please select a location on the map.");
      return;
    }

    if (!category) {
      alert("Category details are missing.");
      return;
    }

    try {
      const user = auth.currentUser;
      if (!user) {
        alert("User not authenticated.");
        return;
      }

      // Generate a random ID
      const customId = generateCustomId();
      // Generate a 15-digit order number
      const orderNumber = generateOrderNumber();
      const clientName = user.displayName || ""; // Use a default name if displayName is missing
      const orderTestRef = collection(db, "order_test");

      const latitude = Number(mapLocation.latitude);
      const longitude = Number(mapLocation.longitude);

      // Check for duplicate entries
      const q = query(
        orderTestRef,
        where("client_location.latitude", "==", latitude),
        where("client_location.longitude", "==", longitude),
        where("client_name", "==", clientName)
      );

      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        alert("This location already exists in your records.");
        return;
      }

      const currentDate = new Date();

      // Format datetime as: January 21, 2025 at 12:00:00 AM UTC+5:30
      const formattedDatetime = format(
        currentDate,
        "MMMM d, yyyy 'at' hh:mm:ss a 'UTC'XXX"
      );

      // Generate document name
      const timestamp = format(currentDate, "yyyy-M-d_H:m:s");
      const randomNumber = Math.floor(Math.random() * 10000000000000000);
      const docName = `${timestamp}_${randomNumber}`;

      const newLocation = {
        // category: category,
        client_location: {
          address: userLocation,
          latitude: latitude,
          longitude: longitude,
        },
        // client_name: clientName,
        // client_user_id: user.uid,
        // datetime: formattedDatetime, // Human-readable datetime
        datetime: Timestamp.now(), // Firestore timestamp
        // id: customId,
        // order: orderNumber,
        order_status: "",
        payment_status: "",
        payment_type: "",
        // promoCode: "",
        // requirements: [],
        // starttime: "",
        // technician_details: {
        //   address: "",
        //   latitude: "",
        //   longitude: "",
        //   workerId: "",
        //   workername: "",
        // },
        // type: "",
        // workinghours: "0",
      };

      await setDoc(doc(db, "order_test", docName), newLocation);

      alert("Location updated successfully in 'order_test'!");
      navigate(routes.bookingPayment, { state: { category } });
    } catch (error) {
      console.error("Error updating Firestore:", error);
      alert("Failed to update location.");
    }
  };

  //Fire Base  Update------------------------- End

  const [userLocation, setUserLocation] = useState("");
  const [mapLocation, setMapLocation] = useState({
    latitude: null,
    longitude: null,
    address: "Click on the map to select a location",
  });

  const [nearTechnicians, setNearTechnicians] = useState([]);
  const [within50kmTechnicians, setWithin50kmTechnicians] = useState([]);

  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey,
    libraries,
  });

  useEffect(() => {
    async function getUserLocation() {
      try {
        const response = await fetch("https://ipapi.co/json/");
        const data = await response.json();
        setUserLocation(`${data.city}, ${data.region}, ${data.country_name}`);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
    getUserLocation();
  }, []);

  const handleMapClick = useCallback(async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setMapLocation({
      latitude: lat,
      longitude: lng,
      address: "Fetching address...",
    });
    fetchTechnicians(lat, lng);
  }, []);

  // Haversine formula to calculate distance
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371e3; // Earth's radius in meters
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in meters
  };

  const fetchTechnicians = async (userLat, userLon) => {
    try {
      const techRef = collection(db, "technicians");
      const techSnapshot = await getDocs(techRef);
      const technicians = [];
  
      techSnapshot.forEach((doc) => {
        const data = doc.data();
        // Directly accessing latitude and longitude if they are available in the document
        const latitude = data.latitude;
        const longitude = data.longitude;
  
        // Ensure both latitude and longitude are available before adding to the list
        if (latitude && longitude) {
          technicians.push({
            id: doc.id,
            name: data.username || "Unknown Technician",
            latitude: latitude,
            longitude: longitude,
          });
        }
      });
  
      let nearTechs = [];
      let within50kmTechs = [];
  
      technicians.forEach((tech) => {
        const distance = calculateDistance(
          userLat,
          userLon,
          tech.latitude,
          tech.longitude
        );
  
        if (distance <= 10000) {
          nearTechs.push(tech);
        } else if (distance <= 50000) {
          within50kmTechs.push(tech);
        }
      });
  
      setNearTechnicians(nearTechs);
      setWithin50kmTechnicians(within50kmTechs);
    } catch (error) {
      console.error("Error fetching technicians:", error);
    }
  };
  

  if (loadError) return <p>Error loading maps</p>;
  if (!isLoaded) return <p>Loading maps...</p>;
  //map-----------------------------end

  return (
    <>
      <BreadCrumb
        title="Bookings"
        item1="Customer"
        item2="Waiting For Technician"
      />

      <div className="page-wrapper">
        <div className="content"
        style={{
          backgroundImage: `url("https://i.postimg.cc/mZ5fxsvz/bg.jpg")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* Booking Step */}

                {/* /Booking Step */}


                {/* Current Location */}
                <div className="booking-service card shadow-none"
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  borderRadius: "15px",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  borderColor: "#ffffff00",
                  color: "#fff",
                }}>
                  <div className="card-body">
                    <h6 className="fs-16 fw-medium mb-0" style={{ color: '#fff' }}>Current Location</h6>
                    <p>
                      <strong>{userLocation}</strong>
                    </p>

                    <h5 style={{ color: '#fff' }}>Select Your Location</h5><br />
                    <GoogleMap
                      mapContainerStyle={mapContainerStyle}
                      zoom={12}
                      center={
                        mapLocation.latitude
                          ? {
                            lat: mapLocation.latitude,
                            lng: mapLocation.longitude,
                          }
                          : center
                      }
                      onClick={handleMapClick}
                    >
                      {/* Marker for user-selected location */}
                      {mapLocation.latitude && mapLocation.longitude && (
                        <Marker
                          position={{
                            lat: mapLocation.latitude,
                            lng: mapLocation.longitude,
                          }}
                        />
                      )}

                      {/* Markers for nearby technicians */}
                      {nearTechnicians.map((tech) => (
                        <Marker
                          key={tech.id}
                          position={{ lat: tech.latitude, lng: tech.longitude }}
                          label={{
                            // text: tech.name,
                            fontSize: "12px",
                            color: "black",
                          }}
                          icon={{
                            url: "https://cdn-icons-png.flaticon.com/512/6342/6342684.png",
                            scaledSize: new window.google.maps.Size(40, 40), // Adjust size as needed
                          }}
                        />
                      ))}


                    </GoogleMap>



                    {/* Display available technicians */}
                    <br /><h5 style={{ color: '#fff' }}>Available Technicians</h5>
                    {nearTechnicians.length > 0 ? (
                      <>
                        <h6 style={{ color: '#fff' }}>Technicians within 10km:</h6>
                        <ul>
                          {nearTechnicians.map((tech) => (
                            <li key={tech.id}>
                              {tech.name}
                              {/* - ({tech.latitude}, {tech.longitude}) */}
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <p style={{ color: '#fff' }}>No technicians available within 10km.</p>
                    )}

                    {within50kmTechnicians.length > 0 && (
                      <>
                        <h6 style={{ color: '#fff' }}>Technicians within 50km:</h6>
                        <ul>
                          {/* {within50kmTechnicians.map((tech) => (
                            <li key={tech.id}>
                              {tech.name} - ({tech.latitude}, {tech.longitude})
                            </li>
                          ))} */}
                          No technicians here Contact Us &nbsp; &nbsp;
                          <button
                            onClick={() =>
                            (window.location.href =
                              "https://api.whatsapp.com/send?phone=919562666362&text=Hi")
                            }
                            style={{
                              marginTop: "5px",
                              padding: "8px 12px",
                              backgroundColor: "#25D366",
                              color: "white",
                              border: "none",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                          >
                            WhatsApp
                          </button>
                        </ul>
                      </>
                    )}
                  </div>
                </div>
                {/* End Current Location */}

                <div className="d-flex align-items-center justify-content-end mt-4">
                  <Link to="#" className="btn btn-light me-2">
                    Cancel
                  </Link>
                  <Button
                    // onClick={handleBookAppointment}
                    onClick={createLocationInFirebase}
                    disabled={!nearTechnicians.length}
                    className="btn btn-dark"
                  >
                    {isFetchingAddress ? "Fetching Address..." : "Make Payment"}
                    {/* Make Payment */}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingReview;
